import { privateClient } from "@/api/privateClient";
import { INSTITUTION_ADMIN_ENDPOINTS } from "../../institutionAdmin.endpoints";
import type { StaffRosterEntry, MarkStaffAttendancePayload, StaffAttendanceSummaryRow } from "../types";

const STAFF_ATTENDANCE = INSTITUTION_ADMIN_ENDPOINTS.STAFF_ATTENDANCE;

export async function fetchRoster(institutionId: number, params: { date: string }): Promise<StaffRosterEntry[]> {
  const { data } = await privateClient.get(STAFF_ATTENDANCE.ROSTER(institutionId), { params });
  return data.roster ?? [];
}

export async function markAttendance(institutionId: number, payload: MarkStaffAttendancePayload): Promise<StaffRosterEntry[]> {
  const { data } = await privateClient.post(STAFF_ATTENDANCE.MARK(institutionId), payload);
  return data.roster ?? [];
}

export async function fetchSummary(
  institutionId: number,
  params: { from?: string; to?: string }
): Promise<StaffAttendanceSummaryRow[]> {
  const { data } = await privateClient.get(STAFF_ATTENDANCE.SUMMARY(institutionId), { params });
  return data.summary ?? [];
}
